import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[var(--agt-navy)] text-white mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="grid place-items-center w-11 h-11 rounded-2xl bg-[var(--agt-mustard)] shadow-md">
              <span className="block w-6 h-6 rounded-md bg-[var(--agt-navy)] grid place-items-center text-[var(--agt-mustard)] font-heading text-xs leading-none">A</span>
            </span>
            <div className="leading-[1.05]">
              <div className="font-heading text-xl text-white">Annuaire</div>
              <div className="text-[0.6rem] tracking-[0.32em] font-black text-[var(--agt-mustard)] uppercase">Grande Taille</div>
            </div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            100% digital, 100% curve. La carte française des boutiques et associations grande taille.
          </p>
        </div>
        <div>
          <h4 className="eyebrow mb-4">Navigation</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/carte" className="text-white/80 hover:text-[var(--agt-mustard)] transition-colors">La carte</Link></li>
            <li><Link to="/blog" className="text-white/80 hover:text-[var(--agt-mustard)] transition-colors">Le blog</Link></li>
            <li><Link to="/abonnement" className="text-white/80 hover:text-[var(--agt-mustard)] transition-colors">S'abonner</Link></li>
            <li><Link to="/contact" className="text-white/80 hover:text-[var(--agt-mustard)] transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="eyebrow mb-4">Catégories</h4>
          <ul className="space-y-2.5 text-sm text-white/80">
            <li><span className="inline-block w-2.5 h-2.5 rounded-full bg-pink-500 mr-2"/>Boutiques femmes</li>
            <li><span className="inline-block w-2.5 h-2.5 rounded-full bg-emerald-500 mr-2"/>Boutiques hommes</li>
            <li><span className="inline-block w-2.5 h-2.5 rounded-full bg-orange-500 mr-2"/>Lingerie</li>
            <li><span className="inline-block w-2.5 h-2.5 rounded-full bg-yellow-400 mr-2"/>Sport</li>
            <li><span className="inline-block w-2.5 h-2.5 rounded-full bg-violet-500 mr-2"/>Mobilier</li>
            <li><span className="inline-block w-2.5 h-2.5 rounded-full bg-blue-500 mr-2"/>Associations</li>
          </ul>
        </div>
        <div>
          <h4 className="eyebrow mb-4">Suivez-nous</h4>
          <div className="flex gap-3">
            <a href="#" className="w-10 h-10 grid place-items-center rounded-full border border-white/30 hover:bg-[var(--agt-mustard)] hover:border-[var(--agt-mustard)] hover:text-[var(--agt-navy)] transition-colors"><Instagram className="w-4 h-4"/></a>
            <a href="#" className="w-10 h-10 grid place-items-center rounded-full border border-white/30 hover:bg-[var(--agt-mustard)] hover:border-[var(--agt-mustard)] hover:text-[var(--agt-navy)] transition-colors"><Facebook className="w-4 h-4"/></a>
            <a href="mailto:contact@annuairegrandetaille.fr" className="w-10 h-10 grid place-items-center rounded-full border border-white/30 hover:bg-[var(--agt-mustard)] hover:border-[var(--agt-mustard)] hover:text-[var(--agt-navy)] transition-colors"><Mail className="w-4 h-4"/></a>
          </div>
          <p className="mt-6 font-heading text-sm text-[var(--agt-mustard)] tracking-widest">« Every body is perfect »</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-[0.7rem] text-white/50 tracking-[0.3em] uppercase">
        © {new Date().getFullYear()} · Annuaire Grande Taille · Tous droits réservés
      </div>
    </footer>
  );
}
